<template>
  <div class="homepage">
    <div class="head">
      <div class="flex">
        <div class="icon1"></div>
        <div class="school" >
          <span @click="choose">{{adminName}}</span>
          <span v-if="role==1">-</span>
          <span v-if="role==1" @click="choose1">{{schoolName}}</span>
          <span v-if="role==0" @click="choose">{{schoolName}}</span>
        </div>
        <div class="icon2" @click="choose"></div>
      </div>
    </div>


    <div class="box">
      <div class="title">
        <div>
          <div class="icon3"></div>
          <div class="txt">数据概览</div>
        </div>
      </div>
      <div class="option">
        <div class="item">
          <div>今日招募</div>
          <div class="num">{{overView.today_reg}}</div>
        </div>
        <div class="item">
          <div>昨日招募</div>
          <div class="num">{{overView.yesterday_reg}}</div>
        </div>
        <div class="item">
          <div>本月招募</div>
          <div class="num">{{overView.month_reg}}</div>
        </div>
        <div class="item">
          <div>累计招募</div>
          <div class="num">{{overView.total_reg}}</div>
        </div>
      </div>
      <div class="option">
        <div class="item">
          <div>新客购买人数</div>
          <div class="num">{{overView.new_buy}}</div>
        </div>
        <div class="item">
          <div>新客购买金额</div>
          <div class="num">￥{{overView.new_order_amount}}</div>
        </div>
        <div class="item">
          <div>老客购买人数</div>
          <div class="num">{{overView.old_buy}}</div>
        </div>
        <div class="item">
          <div>老客购买金额</div>
          <div class="num">￥{{overView.old_order_amount}}</div>
        </div>
      </div>

    </div>
    <div class="box3">
      <div class="total">
        <div class="icon4"></div>
        <div>销售总额:￥</div>
        <div class="total_amount">{{total}}</div>
      </div>
      <div class="title special" v-if="false">
        <div class="group">
          <div class="icon6"></div>
          <input type="text">
        </div>
        <div class="search">查询会员</div>
      </div>

      <div class="content">
        <div class="title special">
          <div>
            <input placeholder="开始日期" type="date" @input="choosestart1" v-model="start_time1"/> —
            <input placeholder="结束日期" type="date" @input="chooseend1" v-model="end_time1"/>
          </div>
        </div>

        <div class="title">
          <div>
            <div class="icon5"></div>
            <div class="txt">会员招募趋势</div>
          </div>
          <div class="check" @click="jump" v-if="!isShow">查看明细</div>
        </div>
        <div id="main" class="main" style="width:100%;height:400px;"></div>
        <div class="flex-center">
          <div class="icon7"></div>
          <div>会员招募人数：{{num}}</div>
        </div>
      </div>
      <div class="content">
        <div class="title special">
          <div>
            <input placeholder="开始日期" type="date" @input="choosestart2" v-model="start_time2"/> —
            <input placeholder="结束日期" type="date" @input="chooseend2" v-model="end_time2"/>
          </div>

<!--          <el-date-picker-->
<!--            v-model="value2"-->
<!--            type="daterange"-->
<!--            range-separator="—"-->
<!--            start-placeholder="开始日期" value-format="yyyy-MM-dd"-->
<!--            end-placeholder="结束日期" @change="choosetime2">-->
<!--          </el-date-picker>-->
        </div>
        <div class="title">
          <div>
            <div class="icon5"></div>
            <div class="txt">会员购买趋势</div>
          </div>
          <div class="check" @click="check" v-if="!isShow">查看明细</div>
        </div>
        <div id="main2" class="main" style="width:100%;height:400px;"></div>
        <div class="flex-center">
          <div class="icon7"></div>
          <div>会员购买金额：￥{{amount}}</div>
        </div>
      </div>

      <div class="content" v-if="isShow">
        <div class="title special">
          <div>
            <input placeholder="开始日期" type="date" @input="choosestart3" v-model="start_time3"/> —
            <input placeholder="结束日期" type="date" @input="chooseend3" v-model="end_time3"/>
          </div>
        </div>
        <div class="title">
          <div>
            <div class="icon5"></div>
            <div class="txt">会员招募排行TOP5</div>
          </div>
          <div class="check" @click="checkenlist" v-if="isShow">查看明细</div>
        </div>
        <div class="group_box">
          <div class="progress_box">
            <dl style="margin-top:0;" v-for="(item,index) in enlists" >
              <span class="nums circle1">{{index+1}}</span>
              <dd>
                <div class="progress" style=" transition: width 1.5s 0s;" :style="{width:item.width,background:item.background}"></div>
                <span class="number">{{item.name}} {{item.user_count}}</span>
              </dd>
            </dl>

            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="none" v-if="none1">暂无数据</div>
      </div>
      <div class="content" v-if="isShow">
        <div class="title special">
          <div>
            <input placeholder="开始日期" type="date" @input="choosestart4" v-model="start_time4"/> —
            <input placeholder="结束日期" type="date" @input="chooseend4" v-model="end_time4"/>
          </div>
        </div>
        <div class="title">
          <div>
            <div class="icon5"></div>
            <div class="txt">会员销售额排行TOP5</div>
          </div>
          <div class="check" @click="checksale" v-if="isShow">查看明细</div>
        </div>
        <div class="group_box">
          <div class="group_box">
            <div class="progress_box">
              <dl style="margin-top:0;" v-for="(item,index) in sales" >
                <span class="nums circle1">{{index+1}}</span>
                <dd>
                  <div class="progress" style=" transition: width 1.5s 0s;" :style="{width:item.width,background:item.background}"></div>
                  <span class="number">{{item.name}} ￥{{item.order_amount}}</span>
                </dd>
              </dl>

              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="none" v-if="none2">暂无数据</div>
      </div>

    </div>
    <div class="foot" v-if="!isShow">
      <div class="tabs on" @click="link(1)">
        <div class="tab tab1"></div>
        <div class="txt">首页</div>
      </div>
      <div class="tabs" @click="link(2)">
        <div class="tab tab2"></div>
        <div class="txt">业绩查询</div>
      </div>
      <div  class="tabs"  @click="link(3)">
        <div class="tab tab3"></div>
        <div class="txt">我的二维码</div>
      </div>
    </div>
    <div class="foot special" v-if="isShow">
      <div class="tabs on" @click="link(1)">
        <div class="tab tab1"></div>
        <div class="txt">首页</div>
      </div>
      <div class="tabs" @click="link(2)">
        <div class="tab tab2"></div>
        <div class="txt">业绩查询</div>
      </div>
    </div>
    <div class="dialog" v-if="role==0" :class="show">
      <div class="fixed"></div>
      <div class="blank">
        <div class="close" @click="close"></div>
        <div class="list">
          <div class="li" :class="item.is_active==true?'':'on'" v-for="(item,index) in schools" @click="chooseSchool(index,schools)">
            <div class="choose"></div>
            <div>{{item.school_name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="picker" v-if="role==1" :class="show">
      <van-picker  show-toolbar title="" :columns="columns" @cancel="cancel" @change="change" @confirm="confirm"/>
      <div class="fixed" ></div>
    </div>
    <div class="picker" v-if="role==1" :class="show2">
      <van-picker  show-toolbar title="" :columns="columns1" @cancel="cancel1" @change="change1" @confirm="confirm1"/>
      <div class="fixed" ></div>
    </div>


  </div>
</template>

<script>
  import '../remh5.js'
  import enlist from '@/components/enlist'
  let role //1管理 0大使
  let school_id
  let link='http://ap.bjcreate.net/school/'
  let openid
  let start_time=''
  let end_time=''
  let date=[]//图表下面的日期
  let data=[]
  let qrcode_id=0
  let index_left=0
  let index_right=0

  export default {
    name: "homepage",
    data () {
      return {
        school_id:'',
        start_time1:'',
        end_time1:'',
        start_time2:'',
        end_time2:'',
        start_time3:'',
        end_time3:'',
        start_time4:'',
        end_time4:'',
        useropenid:'',
        value1:'',
        value2:'',
        show:'',
        isShow:false,
        schools:[],
        schoolName:"",
        adminName:'',
        overView:{},
        total:'',
        enlists:[
          {
            name:'',
            user_count:'',
            width:0.01
          },
          {
            name:'',
            user_count:'',
            width:0.01
          },
          {
            name:'',
            user_count:'',
            width:0.01
          },
          {
            name:'',
            user_count:'',
            width:0.01
          },
          {
            name:'',
            user_count:'',
            width:0.01
          },
        ],
        sales:[
          {
            name:'',
            order_amount:'',
            width:0.01
          },
          {
            name:'',
            order_amount:'',
            width:0.01
          },
          {
            name:'',
            order_amount:'',
            width:0.01
          },
          {
            name:'',
            order_amount:'',
            width:0.01
          },
          {
            name:'',
            order_amount:'',
            width:0.01
          },
        ],
        buylist:[],
        amount:0,
        num:0,
        none1:false,
        none2:false,
        hide:false,
        date: '',
        ambassador:[],
        role:0,
        show2:'',
        columns1: [
          {

          },
        ],
        columns: [
          {

          },
        ],
      }
    },
    /*生命周期 */
    mounted(){
      openid=this.$route.query.o
      role=this.$route.query.r
      this.role=role
      if(role==1){
        this.isShow=true
      }else{
        this.isShow=false
      }
      console.log(openid)
      this.useropenid=openid
      // this.school_id=school_id
      start_time= this.getday(-6)
      end_time= this.getday(0)
      this.start_time1= this.getday(-6)
      this.end_time1= this.getday(0)
      this.start_time2= this.getday(-6)
      this.end_time2= this.getday(0)
      this.start_time3= this.getday(-6)
      this.end_time3= this.getday(0)
      this.start_time4= this.getday(-6)
      this.end_time4= this.getday(0)

      end_time= this.getday(0)
      this.value1=[start_time,end_time]
      this.value2=[start_time,end_time]
      console.log(start_time)
      console.log(this.useropenid)
      this.ismember()
    },
    created() {
      //学校列表



    },
    methods:{
      //是否注册
      ismember(){
        this.$axios.post(link+'api/school/isbind',
          {openid:openid}
        ).then(res=>{
          console.log(res.data)
          if(res.data.Code==200){
            if(role==1){
              //this.getadminschools()
              this.getambassador()
            }else{
              this.getschools()
            }
          }else{
            console.log(openid)
            //window.location.href='http://ap.bjcreate.net/school/school/Login/Index'
          }

        }).catch(error=>{
          console.log(error)
        })
      },

      //大使模块
      //学校列表
      getschools(){
        this.$axios.post(link+'api/school/getschoollist',
          {openid:openid}
        ).then(res=>{
          console.log(res.data)
          res.data.ResultData[0].is_active=false
          this.schools=res.data.ResultData
          this.schoolName=res.data.ResultData[0].school_name
          school_id=res.data.ResultData[0].school_id
          //销售总额 数据概况
          this.getdataview(school_id)
          this.totalsales(school_id)
          this.getenlists(school_id,start_time,end_time)
          this.getbuylists(school_id,start_time,end_time)

        }).catch(error=>{
          console.log(error)
        })
      },
      //数据概况
      getdataview(school_id){
        this.$axios.post(link+'api/school/databrief',
          {
            openid:openid,
            school_id:school_id
          }
        ).then(res=>{
          console.log(res.data)
          this.overView=res.data.ResultData

        }).catch(error=>{
          console.log(error)
        })
      },
      //销售总额
      totalsales(school_id){
        this.$axios.post(link+'api/school/totalsales',
          {
            openid:openid,
            school_id:school_id
          }
        ).then(res=>{
          console.log(res.data)
          this.total=res.data.ResultData[0].order_amount
        }).catch(error=>{
          console.log(error)
        })
      },
      //招募趋势图api/school/getreglist
      getenlists(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getreglist',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time
          }
        ).then(res=>{
          console.log(res.data)
          date=[]
          data=[]
          res.data.ResultData.forEach((value,index)=>{
            value.student_time=value.student_time.split('-')[1]+'.'+value.student_time.split('-')[2]
            value.width=(value.value/100)*3+'rem'
            if(index==0){
              value.background='#FF7731'
            }else if(index==1){
              value.background='#FFAB2C'
            }else if(index==2){
              value.background='#FFBA31'
            }else{
              value.background='#FFEA31'
            }
            date.push(value.student_time)
            data.push(value.reg_count)
            this.num+=value.reg_count
          })
          //this.enlists=res.data.ResultData
          this.drawLine1(date,data)

        }).catch(error=>{
          console.log(error)
        })
      },
      //会员购买趋势图api/school/getreglist
      getbuylists(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getorderamountlist',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time
          }
        ).then(res=>{
          console.log(res.data)
          date=[]
          data=[]
          res.data.ResultData.forEach(value=>{
            value.create_time=value.create_time.split('-')[1]+'.'+value.create_time.split('-')[2]
            date.push(value.create_time)
            data.push(value.order_amount)
            this.amount+=value.order_amount
          })
          this.buylist=res.data.ResultData
          this.drawLine2(date,data)

        }).catch(error=>{
          console.log(error)
        })
      },

      //管理员模块
      //大使列表
      getambassador(){
        this.$axios.post(link+'api/school/adminambassador',
          {
            openid:openid,
          }
        ).then(res=>{
          console.log(res.data)
          this.columns=[]
          res.data.ResultData.forEach(value=>{
             this.columns.push({text:value.real_name})
          })
          this.ambassador=res.data.ResultData
          this.adminName=this.ambassador[0].real_name
          qrcode_id=this.ambassador[0].qrcode_id
          this.getadminschools(this.ambassador[0].qrcode_id)



        }).catch(error=>{
          console.log(error)
        })
      },
      //学校列表
      getadminschools(qrcode_id){
        this.$axios.post(link+'api/school/schoollist',
          {
            openid:openid,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          res.data.ResultData[0].is_active=false
          this.schools=res.data.ResultData
          this.columns1=[]
          res.data.ResultData.forEach(value=>{
              this.columns1.push({text:value.school_name})
          })
          console.log(this.columns1)
          this.schoolName=res.data.ResultData[0].school_name
          school_id=res.data.ResultData[0].school_id
          //销售总额 数据概况
          this.getadmindataview(school_id)
          this.admintotalsales(school_id)
          this.getadminenlists(school_id,start_time,end_time)
          this.getadminbuylists(school_id,start_time,end_time)
          this.getenlistsrank(school_id,start_time,end_time)
          this.getsalesrank(school_id,start_time,end_time)
        }).catch(error=>{
          console.log(error)
        })
      },
      //数据概况
      getadmindataview(qrcode_id){
        this.$axios.post(link+'api/school/admindatabrief',
          {
            openid:openid,
            school_id:school_id,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          this.overView=res.data.ResultData
        }).catch(error=>{
          console.log(error)
        })
      },
      //销售总额
      admintotalsales(school_id){
        this.$axios.post(link+'api/school/admintotalsales',
          {
            openid:openid,
            school_id:school_id,
            qrcode_id:qrcode_id,
            start_time:start_time,
            end_time:end_time
          }
        ).then(res=>{
          console.log(res.data)
          this.total=res.data.ResultData[0].order_amount
        }).catch(error=>{
          console.log(error)
        })
      },
      //招募趋势图api/school/getreglist
      getadminenlists(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getadminreglist',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          date=[]
          data=[]
          res.data.ResultData.forEach((value,index)=>{
            value.student_time=value.student_time.split('-')[1]+'.'+value.student_time.split('-')[2]
            value.width=(value.value/100)*3+'rem'
            if(index==0){
              value.background='#FF7731'
            }else if(index==1){
              value.background='#FFAB2C'
            }else if(index==2){
              value.background='#FFBA31'
            }else{
              value.background='#FFEA31'
            }
            date.push(value.student_time)
            data.push(value.reg_count)
            this.num+=value.reg_count
          })
          //this.enlists=res.data.ResultData
          this.drawLine1(date,data)

        }).catch(error=>{
          console.log(error)
        })
      },
      //会员购买趋势图api/school/getreglist
      getadminbuylists(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getadminorderamountlist',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          date=[]
          data=[]
          res.data.ResultData.forEach(value=>{
            value.create_time=value.create_time.split('-')[1]+'.'+value.create_time.split('-')[2]
            date.push(value.create_time)
            data.push(value.order_amount)
            this.amount+=value.order_amount
          })
          this.buylist=res.data.ResultData
          this.drawLine2(date,data)

        }).catch(error=>{
          console.log(error)
        })
      },
      //近七日招募排行
      getenlistsrank(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getadminregrank',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)

          if(res.data.ResultData.length>0){
            this.none1=false
            res.data.ResultData.forEach((value,index)=>{
              value.width=(value.user_count/res.data.ResultData[0].user_count)*4+'rem'
              if(index==0){
                value.background='#FF7731'
              }else if(index==1){
                value.background='#FFAB2C'
              }else if(index==2){
                value.background='#FFBA31'
              }else{
                value.background='#FFEA31'
              }
            })
          }else{
            this.none1=true
          }
          this.enlists=res.data.ResultData


        }).catch(error=>{
          console.log(error)
        })
      },
      //近七日招募排行
      getsalesrank(school_id,start_time,end_time){
        this.$axios.post(link+'api/school/getadminorderamountrank',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          if(res.data.ResultData.length>0){
            this.none2=false
            res.data.ResultData.forEach((value,index)=>{
              value.width=(value.order_amount/res.data.ResultData[0].order_amount)*4+'rem'
              if(index==0){
                value.background='#FF7731'
              }else if(index==1){
                value.background='#FFAB2C'
              }else if(index==2){
                value.background='#FFBA31'
              }else{
                value.background='#FFEA31'
              }
            })
          }else{
            this.none2=true
          }

          this.sales=res.data.ResultData

        }).catch(error=>{
          console.log(error)
        })
      },




      chooseSchool(index,schools){
        console.log(index)
        console.log(schools)
        schools.forEach(value=>{
          value.is_active=true
        })
        schools[index].is_active=!schools[index].is_active
        this.schools=schools
        this.schoolName=schools[index].school_name
        school_id=schools[index].school_id
        this.school_id=school_id
        this.show=''
        if(role==1){
          this.getadmindataview(school_id)
          this.admintotalsales(school_id)
          this.getadminenlists(school_id,start_time,end_time)
          this.getadminbuylists(school_id,start_time,end_time)
          this.getenlistsrank(school_id,start_time,end_time)
          this.getsalesrank(school_id,start_time,end_time)
        }else{
          this.getdataview(school_id)
          this.totalsales(school_id)
          this.getenlists(school_id,start_time,end_time)
          this.getbuylists(school_id,start_time,end_time)
        }
        //console.log(schools)

      },

      drawLine1(date,data){
        let option1={
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data:date,
            axisLine: {show:false},//轴线不显示
            axisTick: {show:false},//
            axisLabel: {
              textStyle: {
                color: '#A8A8A8',
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {show:false},//轴线不显示
            axisTick: {show:false},//
            axisLabel: {
              textStyle: {
                color: '#A8A8A8',
              },
            },
          },
          series: [{
            itemStyle : {
              normal : {
                lineStyle:{
                  color:'#FF9021'
                }
              }
            },
            data: data,
            type: 'line',
            smooth:true,
            areaStyle: {
              normal: {
                color: '#FF9021' //改变区域颜色
              }
            },

          }]
        }
        console.log((this.$echarts))
        let myChart1 = this.$echarts.init(document.getElementById('main'))
        myChart1.setOption(option1);
      },
      drawLine2(date,data){
        let option2={
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data:date,
            axisLine: {show:false},//轴线不显示
            axisTick: {show:false},//
            axisLabel: {
              textStyle: {
                color: '#A8A8A8',
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {show:false},//轴线不显示
            axisTick: {show:false},//
            axisLabel: {
              textStyle: {
                color: '#A8A8A8',
              },
            },
          },
          series: [{
            itemStyle : {
              normal : {
                lineStyle:{
                  color:'#FF9021'
                }
              }
            },
            data: data,
            type: 'line',
            smooth:true,
            areaStyle: {
              normal: {
                color: '#FF9021' //改变区域颜色
              }
            },

          }]
        }
        console.log((this.$echarts))
        let myChart2 = this.$echarts.init(document.getElementById('main2'))
        myChart2.setOption(option2);
      },
      // choosetime:function(e){
      //   console.log(e)
      //   this.getenlists(school_id,e[0],e[1])
      // },
      // choosetime2:function(e){
      //   console.log(e)
      //   this.getbuylists(school_id,e[0],e[1])
      // },
      choosestart1(e){
        this.start_time1=e.target.value
        if(role==0){
          this.getenlists(school_id,this.start_time1,this.end_time1)
        }else{
          this.getadminenlists(school_id,this.start_time1,this.end_time1)
        }
      },
      chooseend1(e){
        this.end_time1=e.target.value
        if(role==0){
          this.getenlists(school_id,this.start_time1,this.end_time1)
        }else{
          this.getadminenlists(school_id,this.start_time1,this.end_time1)
        }
      },
      choosestart2(e){
        this.start_time2=e.target.value
        if(role==0){
          this.getbuylists(school_id,this.start_time2,this.end_time2)
        }else{
          this.getadminbuylists(school_id,this.start_time2,this.end_time2)
        }
      },
      chooseend2(e){
        this.end_time2=e.target.value
        if(role==0){
          this.getbuylists(school_id,this.start_time2,this.end_time2)
        }else{
          this.getadminbuylists(school_id,this.start_time2,this.end_time2)
        }
      },
      choosestart3(e){
        this.start_time3=e.target.value
        this.getenlistsrank(school_id,this.start_time3,this.end_time3)
      },
      chooseend3(e){
        this.end_time3=e.target.value
        this.getenlistsrank(school_id,this.start_time3,this.end_time3)
      },
      choosestart4(e){
        this.start_time4=e.target.value
        this.getsalesrank(school_id,this.start_time4,this.end_time4)
      },
      chooseend4(e){
        this.end_time4=e.target.value
        this.getsalesrank(school_id,this.start_time4,this.end_time4)
      },
      choose(){
        this.show='on'
      },
      choose1(){
        this.show2='on'
      },
      close(){
        this.show=''
      },
      jump(item) {
        console.log(item)
        this.$router.push({
          path:'enlist?openid='+openid+'&school_id='+school_id+'&start_time='+start_time+'&end_time='+end_time
          //path:'detail?id='+item.id
          //name:`detail`,query:{id:item.id}
        })
      },
      check(item) {
        console.log(item)
        this.$router.push({
          path:'sale?openid='+openid+'&school_id='+school_id+'&start_time='+start_time+'&end_time='+end_time
          //path:'detail?id='+item.id
          //name:`detail`,query:{id:item.id}
        })
      },
      checkenlist(){
        this.$router.push({
          path:'enlistDetail?openid='+openid+'&school_id='+school_id+'&start_time='+this.start_time3+'&end_time='+this.end_time3+'&role='+role+'&qrcode_id='+qrcode_id
          //path:'detail?id='+item.id
          //name:`detail`,query:{id:item.id}
        })
      },
      checksale(){
        this.$router.push({
          path:'saleDetail?openid='+openid+'&school_id='+school_id+'&start_time='+this.start_time4+'&end_time='+this.end_time4+'&role='+role+'&qrcode_id='+qrcode_id
          //path:'detail?id='+item.id
          //name:`detail`,query:{id:item.id}
        })
      },
      link(e){
        console.log(e)
        if(e==1){

        }else if(e==2){
          this.$router.push({
            path:'search?openid='+openid+'&role='+role+'&qrcode_id='+qrcode_id+'&school_id='+school_id
          })
        }else{
          if(role==1){

          }else{
            this.$router.push({
              path:'my?openid='+openid+'&role='+role
            })
          }

        }
      },
      //获取最近七天
      getday(day){
        var today = new Date();
        var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
        today.setTime(targetday_milliseconds); //注意，这行是关键代码
        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();
        tMonth = this.doHandleMonth(tMonth + 1);
        tDate = this.doHandleMonth(tDate);
        return tYear+"-"+tMonth+"-"+tDate;
      },
      doHandleMonth(month){
        var m = month;
        if(month.toString().length == 1){
          m = "0" + month;
        }
        return m;
      },
      cancel(e){
        this.show=''
      },
      change(e){
        console.log(e)
        index_left=e.children[0].currentIndex
        //index_right=e.children[1].currentIndex
      },
      confirm(e){
        console.log(e)
        this.show=''
        qrcode_id=this.ambassador[index_left].qrcode_id
        this.adminName=this.ambassador[index_left].real_name
        this.getadminschools(qrcode_id)
      },
      cancel1(e){
        this.show2=''
      },
      change1(e){
        //index_left=e.children[0].currentIndex
        index_right=e.children[0].currentIndex
      },
      confirm1(e){
        this.show2=''
        school_id=this.schools[index_right].school_id
        this.schoolName=this.schools[index_right].school_name
        //this.getadminschools(qrcode_id,index_right)
        this.getadmindataview(school_id)
        this.admintotalsales(school_id)
        this.getadminenlists(school_id,start_time,end_time)
        this.getadminbuylists(school_id,start_time,end_time)
        this.getenlistsrank(school_id,start_time,end_time)
        this.getsalesrank(school_id,start_time,end_time)
      },

    },
    components:{
      enlist
    }
  }

</script>

<style scoped>
  .school{
    max-width:5rem;
  }
   .picker{
     width:100%;
     position: fixed;
     left:0;
     bottom:0;
     z-index: 50;
     visibility: hidden;
     -webkit-transition: visibility 0.5s 0s;
     transition: visibility 0.5s 0s;
   }
   .picker.on{
     visibility:visible;transition: visibility 0.5s 0s;
   }
   .van-picker{
     z-index:20;
     width:100%;
     opacity: 0;
     -webkit-transition: opacity 0.5s 0s;
     transition: opacity 0.5s 0s;
   }
   .picker.on .van-picker{
     opacity: 1;
     visibility:visible;transition: visibility 0.5s 0s;
   }
   .el-date-range-picker{
    width:300px;
  }
  .contains{
    padding-bottom:1.6rem;
  }
  .foot{
    position: fixed;
    width:100%;
    height:1.3rem;
    background-color:#fff;
    left:0;
    bottom:0;
    font-size:0.22rem;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top:0.2rem;
    color:#A8A8A8;
    box-shadow:2px 0px 5px rgba(0,0,0,0.2);
  }
  .foot.special{
    justify-content: center;
  }
  .foot>.tabs{
    width:2.3rem;
    text-align: center;
  }
  .foot.special>.tabs{
    width:3.3rem;
    text-align: center;
  }
  .tab1{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon9.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab1{
    background: url(../assets/icon9-on.png) no-repeat center top;
    background-size: 100%;
  }
  .foot>.on .txt{
    color:#FF9831;
  }

  .tab2{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon10.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab2 {
    background: url(../assets/icon10-on.png) no-repeat center top;
    background-size: 100%;
  }
  .tab3{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon16.jpg) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab3{
    background: url(../assets/icon16-on.jpg) no-repeat center top;
    background-size: 100%;
  }
  a{
    text-decoration:none;
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #000;
  }
  .txt{
    color:#000;
  }
  /*公共样式-szs*/
  .none{
    text-align: center;
    color:#666;
    font-size:0.3rem;
    padding:1rem 0;
    background-color:#fff;
  }
  html{font-size:62.5%;}
  .homepage{
    background-color:#f2f2f2;
    padding-bottom: 1.6rem;
  }
  body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td {
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }
  .el-date-editor--daterange.el-input__inner{
    width:280px;
    /*margin-left:0.2rem;*/
  }
  html{
    width:100%;
    height:100%;
  }
  ul{
    list-style:none;
  }
  .clear{clear:both;}
  body {
    color: #000;
    font-family:Microsoft YaHei;
    font-size:62.5%;
    width:100%;
    height: 100%;
    line-height: 1;
    margin: 0 auto;
    background-color:#F2F2F2;
  }
  *{
    -webkit-tap-highlight-color:rgba(0, 0, 0, 0);
  }
  .contains{
    width:100%;
    overflow: hidden;
  }
  .head{
    width:100%;
    height:2rem;
    background-image: linear-gradient(#FEA827, #FF8636);
    overflow: hidden;
  }
  .flex{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:0.38rem;
    color:#fff;
    margin-top:0.35rem;
  }
  .icon1{
    width:0.47rem;
    height:0.45rem;
    background: url(../assets/icon14.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.3rem;
    margin-left:0.38rem;
  }
  .icon2{
    width:0.26rem;
    height:0.26rem;
    background: url(../assets/icon6.png) no-repeat center top;
    background-size: 100%;
    margin-left:0.3rem;
  }
  .box{
    width:7.3rem;
    min-height:3rem;
    margin:-0.5rem auto 0;
    border-radius:9px;
    background-color:#fff;
    padding-bottom:1rem;
    overflow: hidden;
  }
  .box3{
    width:7.3rem;
    min-height:3rem;
    margin:0rem auto 0;
    border-radius:9px;
    overflow: hidden;
  }
  .title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height:0.8rem;
    font-size:0.32rem;
    padding:0 0.26rem;
    background-color: #fff;
    max-width:6.8rem;
    margin:0 auto 0;
  }
  .title.special{
    /*margin-bottom:0.2rem;*/
    padding:0.2rem 0.26rem;
  }
  .title input{
    height:1rem;
    line-height:1rem;
    border:1px solid #ddd;
    background-color:#fff;
    padding-left:0.1rem;
    font-size:0.3rem;
    outline: none;
    -webkit-appearance: none;
  }
  .icon3{
    display: inline-block;
    width:0.33rem;
    height:0.29rem;
    background: url(../assets/icon4.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    vertical-align: middle;
  }
  .option{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:0.5rem;
  }
  .item{
    flex:1;
    font-size:0.24rem;
    text-align:center;
  }
  .item .num{
    color:#FF9831;
    font-size: 0.32rem;
    margin-top:0.2rem;
  }
  .total{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width:100%;
    height:1.3rem;
    line-height:1.3rem;
    background-color:#FF961E;
    border-radius:10px;
    margin-top:0.2rem;
    font-size:0.32rem;
    color:#fff;
    margin-bottom:0.2rem;
  }
  .icon4{
    width:1.29rem;
    height:1.01rem;
    background: url(../assets/icon15.png) no-repeat center center;
    background-size: 100%;
    margin-left:0.8rem;
    margin-right:0.2rem;
  }
  .total_amount{
    font-size:0.5rem;
  }
  .icon5{
    display: inline-block;
    width:0.28rem;
    height:0.29rem;
    background: url(../assets/icon5.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    vertical-align: middle;
  }
  .txt{
    display: inline-block;
    vertical-align: middle;
  }
  .check{
    color:#FF961E;
    text-decoration: underline;
  }
  .search{
    width:1.44rem;
    height:0.56rem;
    line-height:0.56rem;
    text-align:center;
    color:#fff;
    font-size:0.22rem;
    background-color:#FF961E;
    border-radius:25px;
  }
  .group{
    width:5rem;
    height:0.56rem;
    line-height:0.56rem;
    border:1px solid #D9D9D9;
    border-radius:3px;
  }
  .icon6{
    display: inline-block;
    width:0.26rem;
    height:0.26rem;
    background: url(../assets/icon13.png) no-repeat center top;
    background-size: 100%;
    margin-right:0.2rem;
    margin-left:0.3rem;
    vertical-align: middle;
  }
  .group input{
    border:none;
    outline:none;
    height:0.56rem;
    line-height:0.56rem;
    vertical-align: middle;
    background-color:transparent;
  }
  .main{
    background-color:#fff;
  }
  .flex-center{
    display: flex;
    align-items: center;
    justify-content:center;
    font-size:0.24rem;
    background-color:#fff;
    padding-bottom:0.3rem;
    color:#999;
  }
  .icon7{
    width:0.27rem;
    height:0.17rem;
    background-color: #FF9000;
    border-radius:3px;
    margin-right:0.2rem;
  }
  .content{
    margin-top:0.2rem;
    border-radius:9px;
    overflow: hidden;
  }
  /*进度条*/
  .progress_box{
    /*height:5.4rem;*/
    overflow-y: auto;
    overflow-x:hidden;
    padding-top:0.4rem;
  }
  dl{
    height: 0.6rem;
    line-height: 0.5rem;
    margin-left:0.55rem;
    margin-top:0.3rem;
  }
  dt{
    width:1rem;
  }
  dd{
    float: left;
    margin-left:0.1rem;
  }
  dd div.progress{
    background-color:#CE000D;
    height:0.12rem;
    width:0;
    margin-top:0.08rem;
    float: left;
    transition: width 1.5s 0s;
  }
  dd p{
    color:#4F4F4F;
    font-size:0.25rem;
  }
  dd p>span{
    display: inline-block;
    font-size:0.2rem;
    margin-left:0.15rem;
  }
  .nums {
    display: inline-block;
    float: left;
    color:#4F4F4F;
    font-size:0.25rem;
    width: 0.33rem;
    height: 0.33rem;
    line-height: 0.33rem;
    text-align: center;
    border-radius: 50%;
  }
  .number{
    display: inline-block;
    float: left;
    color:#957057;
    margin-left:0.15rem;
    margin-top:-0.1rem;
    font-size:0.25rem;
  }
  .group_box{
    background-color:#fff;
  }

  /*选择学校*/
  .dialog{
    visibility:hidden;transition: visibility 0s 0.5s;
  }
  .dialog.on{
    visibility:visible;transition: visibility 0s 0s;
  }
  .fixed{
    position: fixed;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.6);
    z-index:10;
    left:0;
    top:0;
    opacity: 0;transition: opacity 0.5s 0s;
  }
  .on .fixed{
    opacity: 1;transition: opacity 0.5s 0s;
  }
  .blank{
    width:100%;
    background-color:#fff;
    position: fixed;
    left:0;
    top:-600px;
    z-index:20;
    min-height:5rem;
    transition: top 0.5s 0s;
  }
  .on .blank{
    top:-0px;
    transition: top 0.5s 0s;
  }
  .close{
    position: absolute;
    width:0.5rem;
    height:0.5rem;
    right:0.2rem;
    top:0.2rem;
    background: url(../assets/icon8.png) no-repeat center center;
    background-size: 50%;
  }
  .list{
    width:6.47rem;
    margin:0.5rem auto 0;
  }
  @keyframes donghua{
    0%{-webkit-transform: translateY(-600px);transform: translateY(-600px);}
    100%{-webkit-transform: translateY(0rem);transform: translateY(0rem);}
  }
  .list .li{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom:1px solid #DBDBDB;
    height:1rem;
    font-size:0.28rem;
  }
  .list .li .choose{
    width:0.22rem;
    height:0.22rem;
    border-radius:50%;
    margin-right:0.6rem;
    background: url(../assets/icon7.png) no-repeat center center;
    background-size: 100%;
  }
  .list .li.on .choose{
    background: url(../assets/icon7-on.png) no-repeat center center;
    background-size: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/components/homepage.vue